import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DataModel, DataModelClass } from "src/formBuilder/datamodel/structure";
import { GetAllTemplateMessage } from "src/formBuilder/formBuilder/formBuilder/formBuilder-viewModel";
import { TemplateViewModel } from "src/formBuilder/formBuilder/templateList/templateList-viewModel";
import { GetDataModelMessage } from "../../../templateEditor-viewModel";
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { TemplateSelectorEditorView } from "./templateSelectorEditor-view"

export class TemplateSelectorEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.selector = new TemplateSelectorComboBox(this);
        this.ifElseSelectors = ObservableArray.create<IfElseGenerator>();
    }
    GetDefaultView(): View <ViewModel> {
        return new TemplateSelectorEditorView();
    }
    public getTypeId(): string {
        return "VM-116CB16B-C490-4BC6-9B07-9EB75F0B6E85"
    }

    public set selector(v: TemplateSelectorComboBox) { this._selector = v; } public get selector(): TemplateSelectorComboBox { return this._selector;} private _selector: TemplateSelectorComboBox;
    public set ifElseSelectors(v: ObservableArray<IfElseGenerator>) { this._ifElseSelectors = v; } public get ifElseSelectors(): ObservableArray<IfElseGenerator> { return this._ifElseSelectors;} private _ifElseSelectors: ObservableArray<IfElseGenerator>;
    

    addNew(){
        let generator = new IfElseGenerator(this);
        this.ifElseSelectors.push(generator);
    }
    remove(ifElse:IfElseGenerator){
        this.ifElseSelectors.remove(ifElse);
    }

    setValue(v: string) {
        this.ifElseSelectors.clear();
        this.selector.selectById(null);
        if(stringIsNullOrEmpty(v)){
            return;
        }
        let lines = v.split('\r\n');
        lines.forEach(line => {
            let matchResult = line.trim().match(/.*=='(.*)'\) (return '.*';)/);
            if(matchResult!=null){
                let template = matchResult[2];
                let className = matchResult[1];
                let selector = new IfElseGenerator(this);
                selector.classSelector.selectById(className);
                selector.templateSelector.selectById(template);
                this.ifElseSelectors.push(selector);
            }else{
                this.selector.selectById(line);
            }
        });
    }
    getValue(): string {
        let lines : string[] = [];
        this.ifElseSelectors.forEach(element => {
            if(element.classSelector.selectedItem!=null && element.templateSelector.selectedItem!=null)
                lines.push(`if(vm.__GetClassName__()=='${element.classSelector.selectedItem.id}') ${element.templateSelector.selectedItem.id}`);
        });
        if(this.selector.selectedItem!=null){
            lines.push(this.selector.selectedItem.id);
        }
        if(lines.length==0)
            return null;
        else
            return lines.join('\r\n');
    }

    requestConfirm() {
    }

}

export class IfElseGenerator extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:TemplateSelectorEditorViewModel) {
        super(parent);
        this.typedParent = parent;
        this.templateSelector = new TemplateSelectorComboBox(this);
        this.classSelector = new DataModelClassSelector(this);
    }
    public set templateSelector(v: TemplateSelectorComboBox) { this._templateSelector = v; } public get templateSelector(): TemplateSelectorComboBox { return this._templateSelector;} private _templateSelector: TemplateSelectorComboBox;
    public set classSelector(v: DataModelClassSelector) { this._classSelector = v; } public get classSelector(): DataModelClassSelector { return this._classSelector;} private _classSelector: DataModelClassSelector;
    private typedParent:TemplateSelectorEditorViewModel;
    remove(){
        this.typedParent.remove(this);
    }
    
}
export class TemplateSelectorComboBox extends SelectorBaseViewModel<idName>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    protected loadData(): Promise<idName[]> {
        let templates = <TemplateViewModel[]>this.handleMessage(new GetAllTemplateMessage());
        let result = templates.map(x=>{
            let r = new idName(this);
            r.id = `return '${x.name}';`;
            r.title = x.name;
            r.template = x;
            return r;
        });
        let empty = new idName(this);
        empty.id = `return '';`
        empty.title = 'null';
        empty.template = null;
        result.unshift(empty);
        return Promise.resolve(result);
    }
    
}
export class idName extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set template(v: TemplateViewModel) { this._template = v; } public get template(): TemplateViewModel { return this._template;} private _template: TemplateViewModel;
}

export class DataModelClassSelector extends SelectorBaseViewModel<classIdName>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    protected loadData(): Promise<classIdName[]> {
        let model : DataModel = this.handleMessage(new GetDataModelMessage())
        let classes = model.classes.map(x=>{
            let r = new classIdName(this);
            r.id = x.name;
            r.title = x.name;
            r.classObject = x;
            return r;
        });
        return Promise.resolve(classes);
    }
}

export class classIdName extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set classObject(v: DataModelClass) { this._classObject = v; } public get classObject(): DataModelClass { return this._classObject;} private _classObject: DataModelClass;
}